import Select from "react-select"; // ✅
import React, { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import {
  getservice_Categories,
  getCourt_Case_Types,
} from "../../services/Common";

const CaseBasicInfo = ({
  control,
  errors,
  lang,
  enPhrase,
  arPhrase,
  isLoading,
  isRtl,
  isSearchable,
  courts,
  caseTypes,
  years,
  partyTypes,
  sharedValues,
  setSharedValues,
  clearErrors,
  register,
  CustomDropdownIndicator,
  formatOptionLabel,
  optionsYear,
  setServiceCaregories,
  resetAllDisclosures,
  setCaseTypes,
  setValue,
  setMobileNumber,
  mobileNumber,
}) => {
  const [isCaseTypesLoading, setIsCaseTypesLoading] = useState(false);
  const [countries, setCountries] = useState([]);
  const isCaseTypeDisabled =
    !sharedValues?.court?.id || isCaseTypesLoading || !caseTypes?.length;

  console.log("SharedValues", sharedValues);

  function customTheme(theme) {
    return {
      ...theme,
      colors: {
        ...theme.colors,
        primary25: "#F9F7ED",
        primary: "#B68A35",
        neutral0: "white", // Ensure menu background stays white
      },
    };
  }

  const customStyles = {
    control: (base, state) => ({
      ...base,
      background: state.isDisabled ? "#EFEFEF" : "#fff", // gray background when disabled
      borderRadius: 4,
      "*": {
        boxShadow: "none !important",
      },
      backgroundColor: state.isFocused ? "#fffff0" : "#fff",
    }),
    menu: (base) => ({
      ...base,
      borderRadius: 0,
      marginTop: 0,
      height: "auto",
      overflow: "auto",
    }),
    menuList: (base) => ({
      ...base,
      padding: 0,
      backgroundColor: "#fff", // Keep background white to avoid overriding
      maxHeight: "200px",
    }),
    option: (base, { isSelected, isFocused }) => ({
      ...base,
      backgroundColor: isSelected ? "#B68A35" : isFocused ? "#F9F7ED" : "white",
      color: isSelected ? "white" : "black",
      ":hover": {
        backgroundColor: isSelected ? "#B68A35" : "#F9F7ED",
        color: "black",
      },
    }),
    indicatorSeparator: (base) => ({
      ...base,
      display: "none",
    }),
  };

  const codeChangeHandler = (selectedOption) => {
    console.log("selectedOption", selectedOption?.target?.value?.dial_code);
    setMobileNumber({
      ...mobileNumber,
      country_code: selectedOption?.target?.value?.dial_code,
    });
    clearErrors("code");
    clearErrors("mobile");
  };

  useEffect(() => {
    if (lang === "en") {
      const data = require("../../components/ContactusModel/countriesEn.json");
      setCountries(data);
    } else {
      const dataAr = require("../../components/ContactusModel/countriesAr.json");
      setCountries(dataAr);
    }
    console.log("data,data", countries);
  }, [lang]);

  const formatOptionLabelCode = ({ name, dial_code, code }, { context }) => {
    if (context === "menu") {
      return (
        <div className="flex flex-col gap-[8px] items-center" value={dial_code}>
          <div className="flex flex-row gap-[8px] items-center">
            <img
              alt={name}
              src={`http://www.geonames.org/flags/x/${code.toLowerCase()}.gif`}
              className="w-[15px] h-[15px] md:w-[24px] md:h-[15px] rounded-sm"
              onError={(e) => {
                console.error("Failed to load image:", e.target.src);
                e.target.src = "/path-to-fallback-image/fallback.png"; // Specify a fallback image
              }}
            />
            <span className="text-[#333]  text-[12px]" dir="ltr">
              {dial_code}
            </span>
          </div>
          <span className="text-[#333] text-[12px] text-center">{name}</span>
        </div>
      );
    } else {
      // This is how the selected option will be displayed in the input field
      return (
        <div
          className="flex flex-row gap-[30px] items-center"
          value={dial_code}
        >
          <div className="flex flex-row gap-[8px] items-center">
            <img
              src={`http://www.geonames.org/flags/x/${code.toLowerCase()}.gif`}
              alt="country-image"
              className="w-[15px] h-[15px] md:w-[24px] md:h-[16px] rounded-sm"
            />
            <span
              className="text-[#333] font-Almarai font-bold text-[12px]"
              dir="ltr"
            >
              {dial_code}
            </span>
          </div>
        </div>
      );
    }
  };

  // const formatOptionLabelCode = ({ name, dial_code, code }, { context }) => {
  //   if (context === "menu") {
  //     return (
  //       <div className="flex flex-col gap-[4px] items-start p-1">
  //         <div className="flex flex-row gap-[8px] items-center">
  //           <img
  //             alt={name}
  //             src={`http://www.geonames.org/flags/x/${code.toLowerCase()}.gif`}
  //             className="w-[20px] h-[12px] rounded-sm"
  //           />
  //           <span className="text-white text-[12px]" dir="ltr">
  //             {dial_code}
  //           </span>
  //         </div>
  //         <span className="text-white text-[10px] opacity-80">{name}</span>
  //       </div>
  //     );
  //   }

  //   return (
  //     <div className="flex flex-row gap-[8px] items-center">
  //       <img
  //         src={`http://www.geonames.org/flags/x/${code.toLowerCase()}.gif`}
  //         alt="selected-country"
  //         className="w-[20px] h-[12px] rounded-sm"
  //       />
  //       <span className="text-[#333] font-bold text-[12px]" dir="ltr">
  //         {dial_code}
  //       </span>
  //     </div>
  //   );
  // };

  return (
    <div className="w-full xl:w-[384px] min-h-[484px] bg-[#fff] border-[0.5px] border-[#EEE2D0] shadow-[0px_10px_40px_#361E1214] rounded-[16px] py-[24px] gap-[24px]">
      <div className="flex flex-row gap-[24px] mb-[24px]">
        <img
          src="/assets/img/add-request/Rectangle.svg"
          alt="icon"
          className={`${lang === "en" ? "rotate-180" : ""}`}
        />
        <div className="flex flex-col">
          <p className="font-Almarai font-bold text-[14px] leading-[20px] text-[#0E0D0C]">
            {lang === "en"
              ? enPhrase["lblCaseDetails"]
              : arPhrase["lblCaseDetails"]}
          </p>
          <p className="font-Almarai font-400 text-[11px] leading-[18px] text-[#6F6A62]">
            {lang === "en"
              ? enPhrase["lblBasicInfo"]
              : arPhrase["lblBasicInfo"]}
          </p>
        </div>
      </div>

      <div className="px-[24px] flex flex-col gap-[16px]">
        <div>
          <label
            htmlFor="court"
            className={`block text-[12px] ${
              errors.court
                ? " text-[#E61A05] font-normal"
                : "text-gray-700 font-bold"
            }`}
          >
            {lang === "en"
              ? enPhrase["lblCourtRentalDisputesCenter"]
              : arPhrase["lblCourtRentalDisputesCenter"]}
          </label>
          <Controller
            name="court"
            rules={{
              required: "court is required",
            }}
            control={control}
            render={({ field }) => (
              <Select
                components={{
                  DropdownIndicator: CustomDropdownIndicator,
                }}
                theme={customTheme}
                styles={customStyles}
                noOptionsMessage={() =>
                  lang === "en"
                    ? enPhrase["lblNoResultFound"]
                    : arPhrase["lblNoResultFound"]
                }
                placeholder={
                  <div className="text-gray-600 text-sm">
                    {lang === "en"
                      ? enPhrase["lblCourtRentalDisputesCenterPlaceholder"]
                      : arPhrase["lblCourtRentalDisputesCenterPlaceholder"]}
                  </div>
                }
                label="court"
                error={false}
                {...field}
                classNames={{
                  control: () =>
                    `mt-1 border border-gray-300 text-black focus:!bg-gold-10 !rounded-lg text-[12px] ${
                      errors.court ? "!border-red-600" : "!border-gray-300"
                    }`,
                }}
                classNamePrefix="select"
                defaultValue={courts[0]}
                isLoading={isLoading}
                isRtl={isRtl}
                isSearchable={isSearchable}
                name="caseType"
                options={courts}
                getOptionLabel={(options) => options["name"]}
                getOptionValue={(options) => options["id"]}
                formatOptionLabel={formatOptionLabel}
                onChange={async (selected) => {
                  field.onChange(selected);
                  clearErrors("court");
                  resetAllDisclosures();
                  setValue("caseType", null);
                  // reset dependent fields
                  setSharedValues((prev) => ({
                    ...prev,
                    court: selected,
                    caseType: null,
                  }));
                  // control?.setValue?.("caseType", null, {
                  //   shouldValidate: true,
                  // });

                  // disable caseType until we load
                  setCaseTypes([]);
                  setIsCaseTypesLoading(true);

                  if (!selected?.id) {
                    setServiceCaregories([]);
                    setSharedValues((prev) => ({
                      ...prev,
                      serviceCategories: [],
                    }));
                    setIsCaseTypesLoading(false);
                    return;
                  }

                  try {
                    const [categoriesRes, caseTypesRes] = await Promise.all([
                      getservice_Categories(lang, selected.id),
                      getCourt_Case_Types(lang, selected.id),
                    ]);

                    setSharedValues((prev) => ({
                      ...prev,
                      serviceCategories: categoriesRes ?? [],
                    }));
                    setServiceCaregories(categoriesRes ?? []);

                    setCaseTypes(caseTypesRes ?? []);
                  } catch (e) {
                    console.error(e);
                    setServiceCaregories([]);
                    setSharedValues((prev) => ({
                      ...prev,
                      serviceCategories: [],
                    }));
                    setCaseTypes([]);
                  } finally {
                    setIsCaseTypesLoading(false);
                  }
                }}
              />
            )}
          />
          {errors.court && (
            <span role="alert" className=" text-xs text-red-600">
              {lang === "en"
                ? enPhrase["drpdwn_Court_error"]
                : arPhrase["drpdwn_Court_error"]}
            </span>
          )}
        </div>
        <div>
          <label
            htmlFor="caseType"
            className={`block text-[12px]  ${
              errors.caseType
                ? " text-[#E61A05] font-normal"
                : "text-gray-700 font-bold"
            }`}
          >
            {lang === "en"
              ? enPhrase["lblCaseTypeEnforcement"]
              : arPhrase["lblCaseTypeEnforcement"]}
          </label>

          <Controller
            name="caseType"
            rules={{
              required: "Case Type is required",
            }}
            control={control}
            render={({ field }) => (
              <Select
                components={{
                  DropdownIndicator: CustomDropdownIndicator,
                }}
                theme={customTheme}
                styles={customStyles}
                noOptionsMessage={() =>
                  lang === "en"
                    ? enPhrase["lblNoResultFound"]
                    : arPhrase["lblNoResultFound"]
                }
                placeholder={
                  <div className="text-gray-600 text-sm">
                    {lang === "en"
                      ? enPhrase["lblCaseTypeEnforcementPlaceholder"]
                      : arPhrase["lblCaseTypeEnforcementPlaceholder"]}
                  </div>
                }
                label="caseType"
                error={false}
                {...field}
                classNames={{
                  control: () =>
                    `mt-1 border border-gray-300 text-black focus:!bg-gold-10 !rounded-lg text-[12px] ${
                      errors.caseType ? "!border-red-600" : "!border-gray-300"
                    }`,
                }}
                isDisabled={isCaseTypeDisabled}
                // isLoading={isCaseTypesLoading}
                classNamePrefix="select"
                // defaultValue={caseTypes[0]}
                // isLoading={isLoading}
                isRtl={isRtl}
                isSearchable={isSearchable}
                name="caseType"
                options={caseTypes}
                getOptionLabel={(options) => options["name"]}
                getOptionValue={(options) => options["id"]}
                formatOptionLabel={formatOptionLabel}
                filterOption={(candidate, input) =>
                  candidate.data.nameForSearch
                    .toLowerCase()
                    .includes(input.toLowerCase())
                } // Search by "nameForSearch"
                onChange={(selected) => {
                  field.onChange(selected);
                  setSharedValues((prev) => ({
                    ...prev,
                    caseType: selected,
                  }));
                  clearErrors("caseType");
                }}
              />
            )}
          />

          {errors.caseType && (
            <span role="alert" className=" text-xs text-red-600">
              {lang === "en"
                ? enPhrase["lbl_Error_Case_Type"]
                : arPhrase["lbl_Error_Case_Type"]}
            </span>
          )}
        </div>

        <div className="col-span-6 sm:col-span-2">
          <div>
            <label
              htmlFor="caseNumber"
              className={`block text-[12px]  ${
                errors.caseNumber
                  ? " text-[#E61A05] font-normal"
                  : "text-gray-700 font-bold"
              }`}
            >
              {lang === "en"
                ? enPhrase["lblCaseNumber"]
                : arPhrase["lblCaseNumber"]}
            </label>
            <input
              type="text"
              name="caseNumber"
              key="caseNumber"
              placeholder={
                lang === "en"
                  ? enPhrase["lblCaseNumberHolder"]
                  : arPhrase["lblCaseNumberHolder"]
              }
              aria-invalid={errors.caseNumber ? "true" : "false"}
              {...register("caseNumber", {
                required: true,
                onChange: (e) => {
                  clearErrors("caseNumber"); // ✅ Clears error
                  setSharedValues((prev) => ({
                    ...prev,
                    caseNumber: e.target.value, // ✅ Updates state
                  }));
                },
              })}
              className={`mt-1 block w-full rounded-md h-[40px] shadow-sm focus:border-gold-100 focus:ring-gold-100 !text-[14px] sm:text-sm leading-[20px] ${
                errors.caseNumber ? " border-red-600" : " border-gray-300"
              }`}
            />
            {errors.caseNumber && (
              <span role="alert" className=" text-xs text-red-600">
                {lang === "en"
                  ? enPhrase["lbl_Case_Number_Error"]
                  : arPhrase["lbl_Case_Number_Error"]}
              </span>
            )}
          </div>
        </div>

        <div className="col-span-6 sm:col-span-2">
          <div>
            <label
              htmlFor="caseYear"
              className={`block text-[12px]  ${
                errors.caseYear
                  ? " text-[#E61A05] font-normal"
                  : "text-gray-700 font-bold"
              }`}
            >
              {lang === "en" ? enPhrase["lblYear"] : arPhrase["lblYear"]}
            </label>

            <Controller
              name="caseYear"
              rules={{
                required: "case Year is required",
              }}
              control={control}
              render={({ field }) => (
                <Select
                  components={{
                    DropdownIndicator: CustomDropdownIndicator,
                  }}
                  theme={customTheme}
                  styles={customStyles}
                  noOptionsMessage={() =>
                    lang === "en"
                      ? enPhrase["lblNoResultFound"]
                      : arPhrase["lblNoResultFound"]
                  }
                  placeholder={
                    <div className="text-gray-600 text-sm">
                      {lang === "en"
                        ? enPhrase["lblYearHolder"]
                        : arPhrase["lblYearHolder"]}
                    </div>
                  }
                  label="caseYear"
                  error={false}
                  {...field}
                  classNames={{
                    control: () =>
                      `mt-1 border border-gray-300 text-black focus:!bg-gold-10 !rounded-lg text-[12px] ${
                        errors.caseYear ? "!border-red-600" : "!border-gray-300"
                      }`,
                  }}
                  classNamePrefix="select"
                  defaultValue={optionsYear[0]}
                  isLoading={isLoading}
                  isRtl={isRtl}
                  isSearchable={isSearchable}
                  name="caseYear"
                  options={optionsYear}
                  getOptionLabel={(options) => options["name"]}
                  getOptionValue={(options) => options["id"]}
                  formatOptionLabel={formatOptionLabel}
                  onChange={(selected) => {
                    field.onChange(selected);
                    setSharedValues((prev) => ({
                      ...prev,
                      caseYear: selected,
                    }));
                    clearErrors("caseYear");
                  }}
                />
              )}
            />

            {errors.caseYear && (
              <span role="alert" className=" text-xs text-red-600">
                {lang === "en"
                  ? enPhrase["lbl_Error_Case_Year"]
                  : arPhrase["lbl_Error_Case_Year"]}
              </span>
            )}
          </div>
        </div>

        <div className="col-span-6 sm:col-span-2">
          <label
            htmlFor="customer"
            className={`block text-[12px]  ${
              errors.customer
                ? " text-[#E61A05] font-normal"
                : "text-gray-700 font-bold"
            }`}
          >
            {lang === "en" ? enPhrase["lblUserType"] : arPhrase["lblUserType"]}
          </label>

          <Controller
            name="customer"
            rules={{
              required: "party Types is required",
            }}
            control={control}
            render={({ field }) => (
              <Select
                components={{
                  DropdownIndicator: CustomDropdownIndicator,
                }}
                theme={customTheme}
                styles={customStyles}
                noOptionsMessage={() =>
                  lang === "en"
                    ? enPhrase["lblNoResultFound"]
                    : arPhrase["lblNoResultFound"]
                }
                placeholder={
                  <div className="text-gray-600 text-sm">
                    {lang === "en"
                      ? enPhrase["lblUserTypeHolder"]
                      : arPhrase["lblUserTypeHolder"]}
                  </div>
                }
                label="customer"
                error={false}
                {...field}
                classNames={{
                  control: () =>
                    `mt-1 border border-gray-300 text-black focus:!bg-gold-10 !rounded-lg text-[12px] ${
                      errors.customer ? "!border-red-600" : "!border-gray-300"
                    }`,
                }}
                classNamePrefix="select"
                defaultValue={partyTypes[0]}
                isLoading={isLoading}
                isRtl={isRtl}
                isSearchable={isSearchable}
                name="customer"
                options={partyTypes}
                getOptionLabel={(options) => options["name"]}
                getOptionValue={(options) => options["id"]}
                formatOptionLabel={formatOptionLabel}
                filterOption={(candidate, input) =>
                  candidate.data.nameForSearch
                    .toLowerCase()
                    .includes(input.toLowerCase())
                } // Search by "nameForSearch"
                onChange={(selected) => {
                  field.onChange(selected);
                  setSharedValues((prev) => ({
                    ...prev,
                    customer: selected,
                  }));
                  clearErrors("customer");
                }}
              />
            )}
          />

          {errors.customer && (
            <span role="alert" className=" text-xs text-red-600">
              {lang === "en"
                ? enPhrase["lblUserTypeError"]
                : arPhrase["lblUserTypeError"]}
            </span>
          )}
        </div>

        {/* <div className="col-span-6 sm:col-span-2">
          <label
            htmlFor="code"
            className={`block text-sm font-medium ${
              errors.mobile ? "text-red-600" : "text-gray-700"
            }`}
          >
            {lang === "en"
              ? enPhrase["lbl_Mobile_Number"]
              : arPhrase["lbl_Mobile_Number"]}
          </label>
          <div className="flex gap-0 relative">
            <input
              type="number"
              name="mobile"
              key="mobile"
              placeholder={
                lang === "en"
                  ? enPhrase["lblMobileNumber"]
                  : arPhrase["lblMobileNumber"]
              }
              aria-invalid={errors.mobile ? "true" : "false"}
              {...register("mobile", {
                required: true,
                maxLength: `${mobileNumber.country_code === "+971" && 9}`,
                minLength: `${mobileNumber.country_code === "+971" && 9}`,
              })}
              className={`absolute w-[61.5%] md:w-[63%] h-[38px]  ${
                lang === "en"
                  ? "left-[38.5%] md:left-[17.5%] border-l-0 rounded-l-none "
                  : "right-[38.5%] md:right-[0%] border-r-0 rounded-r-none "
              } appearance-text mt-1 block  rounded-md    sm:text-sm remove-arrow shadow-sm ${
                errors.mobile || errors.code
                  ? " border-red-600 focus:border-red-600 focus:ring-red-600"
                  : " border-[#cccccc] focus:border-[#ccc] focus:ring-[#cccccc]"
              }`}
            />

            <Controller
              name="code"
              rules={{
                required: "Case Type is required",
                onChange: codeChangeHandler,
              }}
              control={control}
              render={({ field }) => (
                <Select
                  theme={customTheme}
                  styles={customStyles}
                  placeholder={
                    lang === "en"
                      ? enPhrase["lblMobileCode"]
                      : arPhrase["lblMobileCode"]
                  }
                  label="code"
                  error={false}
                  {...field}
                  className={`mt-1 block w-[40%] md:w-[38%] rounded-md border-gray-300 shadow-sm text-sm absolute left-0 ${
                    errors.code ? "!border-red-600" : "border-gray-300"
                  }`}
                  classNamePrefix="select"
                  defaultValue={{
                    name: "United Arab Emirates (UAE)",
                    flag: "🇦🇪",
                    code: "AE",
                    dial_code: "+971",
                  }}
                  isLoading={isLoading}
                  isClearable={false}
                  isRtl={isRtl}
                  isSearchable={isSearchable}
                  name="caseType"
                  options={countries}
                  getOptionValue={(options) => options["id"]}
                  getOptionLabel={(option) =>
                    `${option.name}: ${option.dial_code}`
                  }
                  formatOptionLabel={formatOptionLabelCode}
                />
              )}
            />
          </div>

          {errors.mobile?.type === "minLength" ||
          errors.mobile?.type === "maxLength" ? (
            <span role="alert" className=" text-xs text-red-600">
              {lang === "en"
                ? enPhrase["lbl_error_mobile_number"]
                : arPhrase["lbl_error_mobile_number"]}
            </span>
          ) : errors.code ? (
            <span role="alert" className=" text-xs text-red-600">
              {lang === "en"
                ? enPhrase["lblErrorMobileCode"]
                : arPhrase["lblErrorMobileCode"]}
            </span>
          ) : errors.mobile ? (
            <span role="alert" className=" text-xs text-red-600">
              {lang === "en"
                ? enPhrase["lblErrorMobileNumberFormat"]
                : arPhrase["lblErrorMobileNumberFormat"]}
            </span>
          ) : null}
        </div> */}

        <div className="col-span-6 sm:col-span-2">
          <label
            htmlFor="mobile"
            className={`block text-[12px] mb-1 ${
              errors.mobile || errors.code
                ? "text-[#E61A05] font-normal"
                : "text-gray-700 font-bold"
            }`}
          >
            {lang === "en"
              ? enPhrase["lblMobileNumberOptional"]
              : arPhrase["lblMobileNumberOptional"]}
          </label>

          {/* Main Container: This creates the outer rounded border */}
          <div
            className={`flex flex-row-reverse items-center bg-white h-[40px] rounded-lg border transition-all ${
              errors.mobile || errors.code
                ? "border-red-600"
                : "border-gray-300 focus-within:border-[#B68A35]"
            }`}
          >
            {/* 1. Country Code Select */}
            <div className="w-[130px] h-full">
              <Controller
                name="code"
                rules={{ required: false }}
                control={control}
                render={({ field }) => (
                  <Select
                    {...field}
                    theme={customTheme}
                    // menuIsOpen={true}
                    components={{
                      DropdownIndicator: CustomDropdownIndicator,
                    }}
                    filterOption={(candidate, input) => {
                      const { name, dial_code } = candidate.data;
                      const searchString = `${name} ${dial_code}`.toLowerCase();
                      return searchString.includes(input.toLowerCase());
                    }}
                    styles={{
                      ...customStyles,
                      control: (base) => ({
                        ...base,
                        border: "none",
                        boxShadow: "none",
                        backgroundColor: "transparent",
                        minHeight: "38px",
                        height: "38px",
                      }),
                      valueContainer: (base) => ({
                        ...base,
                        padding: "0 8px",
                        gap: "2px",
                      }),
                      input: (base) => ({
                        ...base,
                        width: 0,
                        minWidth: 0,
                        padding: 0,
                        margin: 0,
                        opacity: 1,
                        caretColor: "transparent",
                      }),

                      // ✅ Fix: Force the menu background to Gold and remove the global white style
                      menu: (base) => ({
                        ...base,
                        backgroundColor: "#B68A35",
                        borderRadius: "4px",
                        marginTop: "4px",
                        zIndex: 9999,
                        border: "none",
                        // width: "334px"
                      }),
                      // ✅ Fix: Override global white background from customStyles
                      menuList: (base) => ({
                        ...base,
                        padding: 0,
                        backgroundColor: "#B68A35", // Ensure this is not white
                      }),
                      option: (base, { isFocused, isSelected }) => ({
                        ...base,
                        backgroundColor: isSelected
                          ? "#fff"
                          : isFocused
                            ? "#c9a154"
                            : "#B68A35",
                        color: "white", // Text must be white for the gold background
                        padding: "10px 12px",
                        cursor: "pointer",
                        borderBottom: "0.5px solid rgba(255, 255, 255, 0.1)", // Subtle separator like screenshot
                        ":active": {
                          backgroundColor: "#9c752d",
                        },
                      }),
                      singleValue: (base) => ({
                        ...base,
                        color: "#000",
                      }),
                    }}
                    options={countries}
                    isRtl={isRtl}
                    isSearchable={true}
                    formatOptionLabel={formatOptionLabelCode}
                    defaultValue={{
                      name: "United Arab Emirates (UAE)",
                      flag: "🇦🇪",
                      code: "AE",
                      dial_code: "+971",
                    }}
                    // onChange={(selected) => {
                    //   field.onChange(selected);
                    //   codeChangeHandler({ target: { value: selected } });
                    // }}
                    onChange={(selected) => {
                      field.onChange(selected); // Updates React Hook Form state

                      // ✅ Update sharedValues for the parent component
                      setSharedValues((prev) => ({
                        ...prev,
                        country_code: selected?.dial_code, // Store the specific dial code
                        selectedCountry: selected, // Store the full object if needed
                      }));

                      // ✅ Update your local mobileNumber state
                      setMobileNumber((prev) => ({
                        ...prev,
                        country_code: selected?.dial_code,
                      }));

                      clearErrors("code");
                    }}
                  />
                )}
              />
            </div>

            {/* 2. THE SEPARATOR: Vertical line matching the screenshot */}
            <div className="w-[1px] h-[24px] bg-[#EEE2D0] shrink-0" />

            {/* 3. Mobile Number Input */}
            <input
              type="number"
              // {...register("mobile", {
              //   required: false,
              //   maxLength: mobileNumber.country_code === "+971" ? 9 : undefined,
              //   minLength: mobileNumber.country_code === "+971" ? 9 : undefined,
              // })}
              {...register("mobile", {
                required: false,
                maxLength: mobileNumber.country_code === "+971" ? 9 : undefined,
                minLength: mobileNumber.country_code === "+971" ? 9 : undefined,
                // onChange: (e) => {
                //   const value = e.target.value;

                //   // ✅ Update sharedValues with the phone number
                //   setSharedValues((prev) => ({
                //     ...prev,
                //     mobile: value,
                //   }));

                //   // ✅ Update local state if you use it for validation/logic elsewhere
                //   setMobileNumber((prev) => ({
                //     ...prev,
                //     number: value,
                //   }));

                //   clearErrors("mobile");
                // },
                onChange: (e) => {
                  const value = e.target.value;

                  setSharedValues((prev) => ({
                    ...prev,
                    mobile: value || null,
                    country_code: value ? prev.country_code : null, // 🔥 KEY LINE
                  }));

                  setMobileNumber((prev) => ({
                    ...prev,
                    number: value,
                    country_code: value ? prev.country_code : null,
                  }));

                  clearErrors("mobile");
                },
              })}
              placeholder={
                lang === "en"
                  ? enPhrase["lblMobileNumber"]
                  : arPhrase["lblMobileNumber"]
              }
              className="flex-1 border-none focus:ring-0 !text-[14px] px-2 bg-transparent h-full remove-arrow"
            />
          </div>

          {/* Error Messages */}
          {(errors.mobile || errors.code) && (
            <span role="alert" className="text-xs text-red-600 mt-1 block">
              {lang === "en"
                ? enPhrase["lbl_error_mobile_number"]
                : arPhrase["lbl_error_mobile_number"]}
            </span>
          )}
        </div>

        {/* <div className="col-span-6 sm:col-span-2">
          <div>
            <label
              htmlFor="Email"
              className={`block text-[12px]  ${
                errors.Email
                  ? " text-[#E61A05] font-normal"
                  : "text-gray-700 font-bold"
              }`}
            >
              البريد الإلكتروني (إختياري)
            </label>
            <input
              type="text"
              name="Email"
              key="Email"
              placeholder={
                // lang === "en"
                //   ? enPhrase["lblCaseNumberHolder"]
                //   : arPhrase["lblCaseNumberHolder"]
                `إدخال البريد الإلكتروني`
              }
              aria-invalid={errors.Email ? "true" : "false"}
              {...register("Email", {
                required: false,
                onChange: (e) => {
                  clearErrors("Email"); // ✅ Clears error
                  setSharedValues((prev) => ({
                    ...prev,
                    email: e.target.value, // ✅ Updates state
                  }));
                },
              })}
              className={`mt-1 block w-full rounded-md h-[40px] shadow-sm focus:border-gold-100 focus:ring-gold-100 !text-[14px] sm:text-sm leading-[20px] ${
                errors.Email ? " border-red-600" : " border-gray-300"
              }`}
            />
            {errors.Email && (
              <span role="alert" className=" text-xs text-red-600">
                {lang === "en"
                  ? enPhrase["lbl_Case_Number_Error"]
                  : arPhrase["lbl_Case_Number_Error"]}
              </span>
            )}
          </div>
        </div> */}
        <div className="col-span-6 sm:col-span-2">
          <div>
            <label
              htmlFor="Email"
              className={`block text-[12px] ${
                errors.Email
                  ? " text-[#E61A05] font-normal"
                  : "text-gray-700 font-bold"
              }`}
            >
              {lang === "en"
                ? enPhrase["lblEmailRequestField"]
                : arPhrase["lblEmailRequestField"]}
            </label>
            <input
              type="text"
              name="Email"
              key="Email"
              placeholder={
                lang === "en"
                  ? enPhrase["lblEmailRequestFieldPlaceHolder"]
                  : arPhrase["lblEmailRequestFieldPlaceHolder"]
              }
              aria-invalid={errors.Email ? "true" : "false"}
              {...register("Email", {
                required: false, // It is optional
                pattern: {
                  value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                  message:
                    lang === "en"
                      ? enPhrase["lblEmailCorrectError"]
                      : arPhrase["lblEmailCorrectError"],
                },
                onChange: (e) => {
                  clearErrors("Email");
                  setSharedValues((prev) => ({
                    ...prev,
                    email: e.target.value,
                  }));
                },
              })}
              className={`mt-1 block w-full rounded-md h-[40px] shadow-sm focus:border-gold-100 focus:ring-gold-100 !text-[13px] sm:text-sm !leading-[20px] ${
                errors.Email ? " border-red-600" : " border-gray-300"
              }`}
            />
            {errors.Email && (
              <span role="alert" className=" text-xs text-red-600">
                {errors.Email.message}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CaseBasicInfo;
